import type { SammelzettelPos } from './api';

export function fmtMenge(n: number): string {
  return Number.isInteger(n) ? String(n) : String(n).replace('.', ',');
}
export function fmtDatum(v: string | null | undefined): string {
  if (!v) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : v;
}
export const STATUS_TXT: Record<SammelzettelPos['status'], { t: string; c: string }> = {
  offen: { t: '○ offen', c: 'text-amber-700' },
  bestellt: { t: '📦 bestellt', c: 'text-sky-700' },
  geliefert: { t: '✅ Wareneingang', c: 'text-emerald-700' },
  storniert: { t: '✕ storniert', c: 'text-slate-400 line-through' },
};

// CSV (Excel-DE: Semikolon, BOM, Dezimalkomma)
export function banfCsv(pos: SammelzettelPos[], nummern: Record<number, number>): string {
  const q = (v: unknown) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  const stand = (p: SammelzettelPos) => p.status === 'offen' && p.rueckfrage === 'wartet' ? 'beim Chef'
    : p.status === 'offen' && p.rueckfrage === 'freigegeben' ? 'offen (freigegeben)' : p.status;
  const kopf = ['Pos', 'Menge', 'ME', 'Kurztext', 'Lieferanten-Art.-Nr.', 'Lieferant', 'Bemerkung', 'Stand', 'Bestell-Nr', 'Bestelldatum', 'Besteller'];
  const zeilen = pos.map(p => [nummern[p.id] ?? '', fmtMenge(p.menge), p.einheit, p.bezeichnung, p.lieferanten_artikelnr, p.lieferant, p.bemerkung, stand(p), p.bestellnr, fmtDatum(p.bestell_datum), p.besteller]);
  return '﻿' + [kopf, ...zeilen].map(r => r.map(q).join(';')).join('\r\n');
}
